import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import "react-data-table-component-extensions/dist/index.css";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import {  Apitoken, Authtoken } from "../Global";
import {MaterialReactTable} from 'material-react-table';
import Swal from 'sweetalert2';
//Material UI Imports
import {

  MenuItem,

} from '@mui/material';
import FindModuleById from '.././FindModuleById';

const PaymentsTerm = () => {
  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]); 

   const [permission, setPermission] = useState({});
  useEffect(() => {
    
     setPermission(FindModuleById(411)); 
    axios.post("/payment-terms/listing",{},{  headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
      .then((response) => {
       
        if (response.data.code === 200) {
          setData(response.data.data.terms);
        }
        else  if (response.data.code === 401) {
          window.location.href = "/login";
        }else{
          window.location.href = "/login"; 
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);


const editItem = (item)=>{
  window.location.href = "/payment-terms-edit/"+item;
}



const deleteItem = (item) => {

  Swal.fire({
    title: 'Do you really want to delete this record?',
    //text: 'This action cannot be undone.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'DELETE'
  }).then((result) => {
    if (result.isConfirmed) {
      axios.get(`/payment-terms/delete/${item}`, {
            headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
          })
          .then((response) => {
            console.log(response);
            if (response.data.code === 200) {
              //setBackendSuccess(response.data.message);
              Swal.fire(
                'Deleted!',
                'Your Record has been deleted.',
                'success'
              );
              setTimeout(() => {
                window.location.href = "/payment-terms";
              }, 500);
            }
          })
          .catch((error) => {
            console.log(error);
          });

      // Handle confirmed action here
      
    }
  });
}

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };


const columns =
 [
  {
    accessorKey: 'name', //normal accessorKey
    header: 'Name',
  },
  {
    accessorKey: 'amount1', //normal accessorKey
    header: 'amount1',
  },
  {
    header: 'amount1',
    accessorFn: (row) => row.amount1+'%',
  },
  {
    header: 'delay1',
    accessorFn: (row) => row.delay1+' week',
  },
  {
    accessorKey: 'amount2', //normal accessorKey
    header: 'amount2',
  },
  {
     header: 'delay2',
    accessorFn: (row) => row.delay2+' week',
  },
  {
    header: 'Created By',
    accessorFn: (row) => `${(row.createdby)?row.createdby.first_name+ ' '+ row.createdby.last_name:""} `,
  },
  {
    header: 'Updated By',
    accessorFn: (row) => `${(row.updatedby)?row.updatedby.first_name+ ' '+ row.updatedby.last_name:""} `,
  },
  ];

  return (
    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={() => toggleMobileMenu()} />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Payment Terms</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/profile">Profile</Link>
                  </li>
                  <li className="breadcrumb-item active">Payment Terms</li>
                </ul>
              </div>
              <div className="col-auto">
                 {permission && permission.add === 1 && (
                  <Link to="/payment-terms-add" className="btn btn-primary me-1">
                    <i className="fas fa-plus"></i>
                  </Link>
                  )} 
              </div>
            </div>
          </div>

          <div className="row">
           
            <div className="col-sm-12">
              <div className="card card-table">
                <div className="card-body">
                  <div className="table-responsive">
                    {permission && permission.list === 1 && ( 
                      <MaterialReactTable columns={columns} data={data} 
                        // enableColumnFilterModes
                        enableColumnOrdering
                        // enableGrouping
                        enablePinning
                        enableRowActions
                        // enableRowSelection
                        // initialState={{ showColumnFilters: true }}
                      
                        renderRowActionMenuItems={({ row }) => [
                            permission?.update === 1 && (
                              <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                                Edit
                              </MenuItem>
                            ),
                            permission?.delete === 1 && (
                              <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                Delete
                              </MenuItem>
                            ),
                          ]}
                    />
                    )}
                  
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default PaymentsTerm;
